import React from 'react';
import tpl from '../templates/main';
import BaseNewCardView from '../../../../Cards/views/BaseNewCardView';

export default class extends BaseNewCardView {
    template = tpl;

    static displayName = 'MoneyAuto.Views.Main';
}
